import(/* webpackMode: "eager", webpackExports: ["SecureCookiesProvider"] */ "/vercel/path0/node_modules/next-client-cookies/dist/provider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/shop/shop-area.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/layout/footers/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/layout/headers/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/layout/wrapper.tsx");
